import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomBadge from '@common/Component/CustomBadge/CustomBadge';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../i18n';

const ProductBadges = ({ badgeDetails, customProps = {}, isSecondSlide = false, isInProductListingPage = false, isPOMEnabled, hasRX }) => {
  const [isClient, setIsClient] = useState(false);
  const [currentLang, setCurrentLanguage] = React.useState('');
  const t = useTranslation();

  let asterBadges = badgeDetails?.asterBadge;
  if (asterBadges?.length >= 2 && badgeDetails?.offerBadge > 0) {
    asterBadges = badgeDetails?.asterBadge.slice(1, 0);
  }

  const renderBadgeItem = (item, index) => {
    let bg = '#74B077'; // Green
    if (asterBadges?.length > 1 && index === 0) {
      bg = '#5E9FDF'; // Blue
    }
    const foregroundColor = item?.foregroundColor || item?.foreground_color || '#ffffff';
    const backgroundColor = item?.backgroundColor || item?.background_color || bg;
    // if (isInProductListingPage) {
    //   foregroundColor = item?.foreground_color ? item?.foreground_color : '#ffffff';
    //   backgroundColor = item?.background_color ? item?.background_color : bg;
    // }
    if (item?.content !== '' && item?.content !== 'null' && item?.content !== null) {
      return (
        <CustomBadge
          key={index}
          customClass="badgeSpecialOffer"
          text={item?.content}
          textColor={foregroundColor}
          backgroundColor={backgroundColor}
          {...customProps}
        />
      );
    } else {
      return '';
    }
  };

  React.useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient || (isPOMEnabled && hasRX)) return null;
  return (
    <div className={`badgeStack ${isSecondSlide === true ? 'noMobile' : ''}`}>
      {badgeDetails?.offerBadge > 0 && (
        <div className="offer-tost">
          {currentLang && isRTL(currentLang)
            ? `%${badgeDetails?.offerBadge} ${t('ProductDetail.offerTxt')}`
            : `${badgeDetails?.offerBadge}% ${t('ProductDetail.offerTxt')}`
          }
        </div>
      )}
      {asterBadges?.length > 0 && [...asterBadges]?.map((item, index) => renderBadgeItem(item, index))}
    </div>
  );
};

ProductBadges.propTypes = {
  badgeDetails: PropTypes.any,
  customProps: PropTypes.any,
  isSecondSlide: PropTypes.any,
  isInProductListingPage: PropTypes.bool,
  isPOMEnabled: PropTypes.bool,
  hasRX: PropTypes.bool,
  pdpPomText: PropTypes.string,
};
ProductBadges.defaultProps = {
  badgeDetails: {},
  customProps: '',
  isSecondSlide: '',
  isInProductListingPage: false,
  isPOMEnabled: false,
  hasRX: '',
  pdpPomText: '',
};  

export default ProductBadges;
